export const setInetStatus = status => ({type: 'SET_INET_STATUS', payload: status});

export const setManageImgStatus = status =>(
    //for madal action status
    {type: 'MANAGE_IMGMODAL_STATUS', payload: status}
);

// export const Counter = count => (
//     {type: 'ADD_COUNT', payload: count}
// )

// export const NewImageAdded = status => (
//     {type: 'NEW_IMAGE_ADDED', payload: status}
// )

export const SetLoggedIn = status => (
    {type: 'SET_LOGGED', payload: status}
)

export const AddtoCart = item => (
    {type: 'ADD2CART', payload: item}
)

export const RemoveFromCart = item => (
    {type: 'REMOVE_FROM_CART', payload: item}
)

export const bkupImages = item => (
    {type: 'BKUP_IMAGES', payload: item}
)

export const bkupCategories = cats => (
    {type: 'BKUP_CATS', payload: cats}
)


// WEBPACK FOOTER //
// ./src/redux/actions/index.js